"use strict";
// shared-utils-lib/src/formatting/ErrorFormatter.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
/**
 * Standard error codes for API responses
 * Used across all services for consistent error handling
 */
var ErrorCode;
(function (ErrorCode) {
    // Client errors (400-499)
    ErrorCode["BAD_REQUEST"] = "BAD_REQUEST";
    ErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ErrorCode["CONFLICT"] = "CONFLICT";
    ErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    // Server errors (500-599)
    ErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    ErrorCode["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
    ErrorCode["DATABASE_ERROR"] = "DATABASE_ERROR";
    ErrorCode["EXTERNAL_API_ERROR"] = "EXTERNAL_API_ERROR";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
